import React, { ComponentProps, forwardRef } from 'react';
import { ButtonGroup as MUIButtonGroup, buttonGroupClasses } from '@mui/material';

import { SHAPE_CIRCULAR, SHAPE_SQUARE } from '@/mui/constants';

import type { ShapeProp } from '@/mui/types';

type Props = ComponentProps<typeof MUIButtonGroup> & {
  shape?: ShapeProp;
};

const ButtonGroup = forwardRef<HTMLDivElement, Props>((props, ref) => {
  const { shape, sx, ...rest } = props;

  return (
    <MUIButtonGroup
      ref={ref}
      {...rest}
      sx={{
        ...(shape === SHAPE_SQUARE && {
          borderRadius: 0,
          [`& .${buttonGroupClasses.middleButton}`]: {
            borderRadius: 0,
          },
          [`& .${buttonGroupClasses.firstButton}`]: {
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
          },
          [`& .${buttonGroupClasses.lastButton}`]: {
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0,
          },
        }),
        ...(shape === SHAPE_CIRCULAR && {
          borderRadius: (theme) => theme.shape.borderRadiusCircular,
          [`& .${buttonGroupClasses.middleButton}`]: {
            borderRadius: (theme) => theme.shape.borderRadiusCircular,
          },
          [`& .${buttonGroupClasses.firstButton}`]: {
            borderTopLeftRadius: (theme) => theme.shape.borderRadiusCircular,
            borderBottomLeftRadius: (theme) => theme.shape.borderRadiusCircular,
          },
          [`& .${buttonGroupClasses.lastButton}`]: {
            borderTopRightRadius: (theme) => theme.shape.borderRadiusCircular,
            borderBottomRightRadius: (theme) => theme.shape.borderRadiusCircular,
          },
        }),
        ...sx,
      }}
    />
  );
});

ButtonGroup.displayName = 'ButtonGroup';

export default ButtonGroup;
